import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";

import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import { v4 as uuidv4 } from 'uuid';
import BenefisciarySubDetails from "./BenefisciarySubDetails";
import { store } from "../../redux/store";
import { setBeneCustomerId, setBeneSubDetails, setBranchAddress, setIfscCode, setOtpResponse, setSelectedBankName, setSelectedBankId, setCreteOrderReq, setCreateOrderRes, setOtpForBeneVerification } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import moment from "moment";
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
const httpClient = axios.create();

class ReviewAddBeneficiary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			errorMessage: '',
			otpNo: ''
		}
	}




	componentDidMount() {

	}
	componentWillUnmount() {
	}

	enterOtp = (event) => {
		event.preventDefault();
		this.setState({
			otpNo: event.target.value
		})
	}


	resendOtp = (event) => {
		event.preventDefault();

		const generateOtprRequestHeader = {
			msgType: "GENERATE_OTP",
			service: "DMT",
			src: "review-sender",
			dst: "review-sender",
			channel: "WHITELABEL",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}

		var customerMobile = '';
		if (this.props.addsenderRequest != '' &&
			this.props.addsenderRequest != null &&
			this.props.addsenderRequest != undefined) {
			customerMobile = this.props.addSenderRequest.customer.mobile;
		} else if (this.props.selectSender != '' &&
			this.props.selectSender != null &&
			this.props.selectSender != undefined) {
			customerMobile = this.props.selectSender.customer.mobile;
		}

		const otp = {
			mobile: customerMobile,
			type: "ADD_DMT_BENEFICIARY"
		}

		const generateOtpRequest = {
			header: generateOtprRequestHeader,
			otpDetails: otp
		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		const otpUrl = "/api/v1/otp/generate";
		httpClient.post(otpUrl, generateOtpRequest, { headers }
		).then((response) => {
			console.log('otp generate and resend' + JSON.stringify(response.data));
			if (response.data.response.msg == 'SUCCESS') {
				store.dispatch(setOtpResponse(response.data));
			} else {
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {
			this.errorMessageCall('Something went wrong in otp resend,please try again later!');
			

		});

	}


	addBeneficiaryDetailsCheck = (event) => {
		event.preventDefault();
		var addBenefisciaryRequest = this.props.benefisciaryRequest;
		var verified = addBenefisciaryRequest.beneficiary.verified;

		if (verified == true) {
			store.dispatch(setOtpForBeneVerification(this.state.otpNo));

			var beneficiaryVerify = document.getElementById('beneficiaryVerify');
			beneficiaryVerify.click();

		} else {
			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}


			var addBenefisciaryRequest = this.props.benefisciaryRequest;

			var addBeneUrl = '/api/v1/dmt/beneficiary/add';



			const otpDetails = {
				mobile: this.props.selectSender.customer.mobile,
				type: 'ADD_DMT_BENEFICIARY',
				refNo: this.props.generateOtpResponse.otpDetails.refNo,
				otp: this.state.otpNo
			}



			const request = {
				header: addBenefisciaryRequest.header,
				beneficiary: addBenefisciaryRequest.beneficiary,
				deviceInfo: this.props.deviceInfo,
				otp: otpDetails,
				customerId: this.props.selectSender.customer.id,
				doVerification: false,
				agentId: this.props.agentInfo.id
			}


			console.log('request::' + JSON.stringify(request));

			httpClient.post(addBeneUrl, request, { headers }
			).then((response) => {
				console.log('register bene response' + JSON.stringify(response.data));
				if (response.data.response.msg == 'SUCCESS') {
					store.dispatch(setBeneCustomerId(response.data.beneficiaryId));


					var beneficiaryDetails = document.getElementById('beneficiaryDetails');
					beneficiaryDetails.click();
		

				} else {
					this.errorMessageCall(response.data.response.displayMsg);
				}
			}).catch(error => {

				this.errorMessageCall('Something went wrong,please try again later!');

				
			});
		}
	}







	addBeneficiary = () => {
		store.dispatch(setSelectedBankName(''));
		store.dispatch(setIfscCode(''));
		store.dispatch(setBranchAddress(''));
		store.dispatch(setSelectedBankId(''));

		var addBeneficiary = document.getElementById('addBeneficiary');
		addBeneficiary.click();
	}


	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}


	render() {
		return (

			<div>

				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">

							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Review - Add Beneficiary</h3>
												<div class="headbtn">
													<button class="dbbtn" onClick={this.addBeneficiary} type="button">Back</button>
												</div>
												<Link to='/add-beneficiary'>
													<button id='addBeneficiary' hidden={true}></button>
												</Link>
												<Link to='/beneficiary-verify'>
													<button id='beneficiaryVerify' hidden={true}></button>
												</Link>
												<Link to='/beneficiary-details'>
													<button id='beneficiaryDetails' hidden={true}></button>
												</Link>

											
											</div>

											<BenefisciarySubDetails />

											<form onSubmit={this.addBeneficiaryDetailsCheck}>
												<div class="dashform">
													<div class="row">
														<div class="col-12 col-md-4">
															<div class="form-floating">
																<input type="number" class="form-control" id="nmae" placeholder="OTP"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 7)}
																	onChange={this.enterOtp}
																	required />
																<label for="nmae">OTP</label>
																<button class="lbbtn otpbtn" type="button"
																	onClick={this.resendOtp}>Resend</button>
																<p class="otptxt">OTP sent via SMS on sender mobile no. {this.props.benefisciaryRequest.beneficiary.mobile.substring(0, 2) +
																	'xxxxxxxx'}.</p>
															</div>
														</div>

														<div class="col-12">
															<div class="form-check">
																<input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
																<label class="form-check-label" for="flexCheckChecked">
																	I agree to the <a href="#">terms and conditions</a>
																</label>
															</div>
														</div>

														<div class="col-12">
															<button type="submit" class="btn btn-primary"
															// onClick={this.beneficiaryDetails}
															>Add Now</button>
														</div>

													</div>
												</div>
											</form>
											{this.state.errorMessage != '' &&
												<div class='valid-error'>
													{this.state.errorMessage}
												</div>}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, benefisciaryRequest, addSenderRequest, ifscCode,
			generateOtpResponse, agentInfo, token, clientRole,clientRequesterId,selectSender, beneCustomerId } }
) => ({
	errorMessage, loginErrorMessage, phone, benefisciaryRequest, addSenderRequest,
	ifscCode, generateOtpResponse, agentInfo, token,clientRole,clientRequesterId, selectSender, beneCustomerId
});

export default connect(mapStateToProps, null)(ReviewAddBeneficiary);
